export class ConnectAzureVaultAccountRequest {
    'tenantId';
    'subscriptionId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ConnectAzureVaultAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
